/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LayoutPhotoStatus } from '../models/LayoutPhotoStatus';
import type { PaginatedLayoutPhotoStatusList } from '../models/PaginatedLayoutPhotoStatusList';
import type { PatchedLayoutPhotoStatus } from '../models/PatchedLayoutPhotoStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsLayoutPhotoStatusService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedLayoutPhotoStatusList
     * @throws ApiError
     */
    public clientsLayoutPhotoStatusList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedLayoutPhotoStatusList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-layout-photo-status/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns LayoutPhotoStatus
     * @throws ApiError
     */
    public clientsLayoutPhotoStatusCreate({
        requestBody,
    }: {
        requestBody: LayoutPhotoStatus,
    }): CancelablePromise<LayoutPhotoStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-layout-photo-status/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns LayoutPhotoStatus
     * @throws ApiError
     */
    public clientsLayoutPhotoStatusRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this layout photo status.
         */
        id: number,
    }): CancelablePromise<LayoutPhotoStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-layout-photo-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns LayoutPhotoStatus
     * @throws ApiError
     */
    public clientsLayoutPhotoStatusUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this layout photo status.
         */
        id: number,
        requestBody: LayoutPhotoStatus,
    }): CancelablePromise<LayoutPhotoStatus> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-layout-photo-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns LayoutPhotoStatus
     * @throws ApiError
     */
    public clientsLayoutPhotoStatusPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this layout photo status.
         */
        id: number,
        requestBody?: PatchedLayoutPhotoStatus,
    }): CancelablePromise<LayoutPhotoStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-layout-photo-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsLayoutPhotoStatusDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this layout photo status.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-layout-photo-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
